import { Avatar, useRuntimeEnv, useTranslationRoute, useTranslations, useUserProfilePicture } from "@bsm/component";
import { useMemo } from "react";

export const useLeftSideBarMenuParameters = () => {

    const [
        PARAMETERS,
        ORGANISATIONS,
        USERS,
        LOGOUT,
        ARTICLE
    ] = useTranslations(i18n)
    const translationRoute = useTranslationRoute();

    const { runtimeEnv } = useRuntimeEnv();

    const profilePictureUrl = useUserProfilePicture()

    return useMemo(() => ({
        ke: "parameters",
        label: PARAMETERS,
        className: "menu-item-category",
        items: [
            // {
            //     label: runtimeEnv?.user.fullName,
            //     startIcon: (
            //         <Avatar
            //             size="xs"
            //             src={profilePictureUrl(runtimeEnv?.user?.id)}
            //             fullName={runtimeEnv?.user?.fullName}
            //         />
            //     ),
            //     link: translationRoute(
            //         `admin/user/${runtimeEnv?.user.id}/about`
            //     ),
            //     isConnected: true,
            //     className: "username-menu",
            // },
            // {
            //     label: runtimeEnv?.organisation?.designation,
            //     link: translationRoute(
            //         `admin/user/organisation/${runtimeEnv.organisation?.id}`
            //     ),
            //     startIcon: "fa-solid fa-building",
            //     roles: ['ORGANISATION']
            // },
            {
                label: LOGOUT,
                startIcon: "fa-solid fa-right-to-bracket",
                link: translationRoute("logout"),
            },
        ],
    }), [])
}

const i18n = [
    'BSM.Admin.LeftSideBar.Menu.Parameters.Label',
    'Harea.Admin.LeftSideBar.Menu.Parameters.Organisations.Label',
    'Harea.Admin.LeftSideBar.Menu.Parameters.Users.Label',
    'BSM.Admin.LeftSideBar.Menu.Parameters.Logout.Label',
    'Harea.Admin.LeftSideBar.Menu.Parameters.Article.Label',
]
